<template>
  <div>
    <dashboard-v2 v-if="displayNewDasboard" />
    <dashboard-v1 v-if="displayNewDasboard === false" />
  </div>
</template>

<script>
import DashboardV1 from './dashboardviews/DashboardV1.vue';
import DashboardV2 from './dashboardviews/DashboardV2.vue';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';

export default {
  name: 'Dashboard',
  components: {
    DashboardV1,
    DashboardV2,
  },
  data() {
    return {
      displayNewDasboard: null,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  async created() {
    const { data } = await _getSysparameterByNames({
      parameterNames: ['DisplayNewDashboardProviders'],
    });
    this.displayNewDasboard =
      data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
  },
};
</script>
